const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/settings/inbox/course-comments/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const courseCommentsSearchSchema = z.object({
  course_id: z.coerce.number().int().positive().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/settings/inbox/course-comments")({
  validateSearch: courseCommentsSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});